import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useI18n } from '../context/I18nContext';
import { hapticLight } from '../utils/haptics';
import './ProductTile.css';

const ProductTile = ({ product, cheapestPrice, cheapestPricePerUnit, cheapestImageUrl, supermarket, supermarketId }) => {
  const { addToCart } = useCart();
  const { t } = useI18n();
  const [quantity, setQuantity] = React.useState(1);
  const hasPrice = Number.isFinite(Number(cheapestPrice));

  const decrement = () => { hapticLight(); setQuantity((prev) => Math.max(1, prev - 1)); };
  const increment = () => { hapticLight(); setQuantity((prev) => prev + 1); };

  const handleAddToCart = () => {
    if (!hasPrice) return;
    hapticLight();
    addToCart(product, {
      price: Number(cheapestPrice),
      supermarket,
      supermarket_id: supermarketId,
    }, quantity);
  };

  return (
    <div className="product-tile">
      <div className="product-media">
        <Link to={`/product/${product.id}`} className="product-image-link" aria-label={t('productTile.openProduct', { name: product.name })}>
          <img
            src={cheapestImageUrl || product.image_url || 'https://via.placeholder.com/135'}
            alt={product.name}
            width={135}
            height={135}
            className="product-image"
          />
        </Link>
      </div>
      <div className="product-header">
        <h3 className="product-name">
          <Link to={`/product/${product.id}`}>{product.name}</Link>
        </h3>
        <div className="product-chips">
          {product.brand && <span className="product-brand">{product.brand}</span>}
          {product.is_by_weight
            ? <span className="product-unit product-unit--by-weight">{t('productTile.pricePerKg')}</span>
            : product.unit && <span className="product-unit">{product.unit}</span>
          }
          {cheapestPricePerUnit && <span className="product-unit-price">{cheapestPricePerUnit}</span>}
        </div>
      </div>

      <div className="product-price-section">
        <div className="price-display">
          {hasPrice ? (
            <span className="price">€{Number(cheapestPrice).toFixed(2)}</span>
          ) : (
            <span className="price unavailable">{t('productTile.priceUnavailable')}</span>
          )}
          {supermarket && (
            <span className="supermarket">{supermarket}</span>
          )}
        </div>
      </div>

      <div className="product-actions-row">
        <div className="quantity-stepper">
          <button type="button" className="qty-btn" onClick={decrement} aria-label={t('productTile.decreaseQuantity')}>-</button>
          <input
            id={`quantity-${product.id}`}
            type="number"
            min="1"
            value={quantity}
            onChange={(e) => setQuantity(Math.max(1, Number(e.target.value) || 1))}
          />
          <button type="button" className="qty-btn" onClick={increment} aria-label={t('productTile.increaseQuantity')}>+</button>
        </div>

        <button className="add-to-cart-btn" onClick={handleAddToCart} disabled={!hasPrice} aria-label={t('productTile.addToCart')}>
          <svg className="add-to-cart-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 4H5L7 14H18L21 7H8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="9" cy="19" r="1.4" fill="currentColor" />
            <circle cx="18" cy="19" r="1.4" fill="currentColor" />
          </svg>
          <span>{t('productTile.addToCart')}</span>
        </button>
      </div>
    </div>
  );
};

export default ProductTile;
